import React from 'react';
import { CopyToClipboardButton } from 'src/components/CopyToClipboardButton';

type Props = {
  signupUrl: string | null | undefined;
};

export const CopySignupLinkButton: React.FC<Props> = ({ signupUrl }) => {
  if (signupUrl == null) return null;

  return (
    <CopyToClipboardButton
      text={signupUrl}
      tooltip="Copy signup link"
      ariaLabel="Copy signup link"
      color="primary"
      showToast
      successMessage="Signup link copied"
    />
  );
};
